import { SlicePipe } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, output, inject, input } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';

import { ChipModule } from 'primeng/chip';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';

import { InplaceModule } from 'primeng/inplace';
import { CONSTANTS_CRM } from '@fitness-force/constants';
import type { Country, ListServiceTypeResponse, OpportunityStageMasterResponse, TENANTSINTERFACE, UpdateOpportunityRequest, UpdateTask } from '@fitness-force/models';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import { TaskAssignToType, TaskType } from '@fitness-force/enum';
import { CurrencyformatPipe } from '@fitness-force/pipes/currency';

import { DateTimeFormatPipe } from '@fitness-force/pipes/datetime-format';
import { StyleClassModule } from 'primeng/styleclass';
import { AutoCompleteModule } from 'primeng/autocomplete';
import {
  COUNTRY_MASTER_STATE,
  STAGE_MASTER_STATE,
  TENANTS_INFO,
} from '@fitness-force/state';
import { AuthSevices, CommonService, TaskService, TimeconversionService,OpportunityService,ServiceTypeService ,ToastMessageService } from '@fitness-force/api';
import { BehaviorSubject } from 'rxjs';

import { DatePickerModule } from 'primeng/datepicker';
import { InputNumberModule } from 'primeng/inputnumber';
import {AssignedToComponent} from '@fitness-force/common/assigned-to'
import { InputNumberComponent } from '@fitness-force/common-input-number';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';

@Component({
  selector: 'app-task-opportunity-info',
  templateUrl: './task-opportunity-info.component.html',
  styleUrls: ['./task-opportunity-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ToastMessageService],
  standalone: true,
  imports: [
    FormsModule,
    DialogModule,
    ButtonModule,
    SelectModule,
    ChipModule,
    InplaceModule,
    StyleClassModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    DatePickerModule,
    InputNumberModule,
    CurrencyformatPipe,
    DateTimeFormatPipe,
    AssignedToComponent,
    InputNumberComponent,
    TranslateModule,
    SlicePipe,
    InputGroupModule,
    InputGroupAddonModule
]
})
export class TaskOpportunityInfoComponent implements OnInit {
  store = inject(Store);
  translate = inject(TranslateService);
  private fb = inject(UntypedFormBuilder);
  private readonly serviceType = inject(ServiceTypeService);
  private readonly taskService = inject(TaskService);
  private readonly opportunityService = inject(OpportunityService);
  private readonly toastMessageService = inject(ToastMessageService);
  private readonly dateTimeService = inject(TimeconversionService);
  private readonly commonService = inject(CommonService);
  private readonly authService = inject(AuthSevices);

  readonly modelData = input<any>(undefined, { alias: "taskOpportunityInfo" });
  readonly ErrorData = output<any>({ alias: 'ErrorData' });
  readonly UpdatedData = output<any>({ alias: 'UpdatedData' });

  TaskApportunityInfoForm!: UntypedFormGroup;
  convertibility: any = CONSTANTS_CRM.OPPORTUNITY_CONVERTITBILITY;
  outcome: any = CONSTANTS_CRM.TOUR_OUTCOME;
  selectedOutcome!: any;
  values: string[] | undefined;
  followUpDate: Date | undefined;
  contractEndDate: Date | undefined;
  mylookupservice: any;
  hideOnOutsideClick: any;
  assignedTo$ = new BehaviorSubject<number>(0);

  serviceTypeCollection!: any;
  assignedCollection!: Assigned[];
  opportunityStageCollection!: Option[];

  errMsg: Error | any;
  tenantId: number = 0;
  taskType: TaskType | any;
  taskNotes: string = '';

  taskTitleEdit: boolean = false;
  taskNotesEdit: boolean = false;
  dueDateEdit: boolean = false;
  amountEdit: boolean = false;
  expectedDateEdit: boolean = false;

  filtertedServiceType!: Option[];

  showErrorPopup$ = new BehaviorSubject(false);
  errorDataModal = [] as any;
  errorMessages = [] as any;
  country: Country;
  minimumDate = new Date();
  
  minDateForEdit!: Date;
  disabledDatesForEdit: Date[] = [];

  openDueDateEdit() {
    this.dueDateEdit = true;
    const scheduled = this.TaskApportunityInfoForm.get('scheduled_date')?.value as Date | string;
    const scheduledDate = scheduled ? new Date(scheduled) : null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    let min = today;
    if (scheduledDate && scheduledDate < today) {
      min = new Date(scheduledDate);
      min.setHours(0, 0, 0, 0);
    }
    this.minDateForEdit = min;

    const dates: Date[] = [];
    if (scheduledDate && scheduledDate < today) {
      const currentDate = new Date(scheduledDate);
      currentDate.setHours(0, 0, 0, 0);
      currentDate.setDate(currentDate.getDate() + 1);

      while (currentDate < today) {
        dates.push(new Date(currentDate));
        currentDate.setDate(currentDate.getDate() + 1);
      }
    }
    this.disabledDatesForEdit = dates;
  }

  
  currentUserDetails:any;



  constructor() {
    this.taskType = TaskType;
    this.currentUserDetails = this.authService.decodedToken;
  }


  ngOnInit(): void {
    this.TaskApportunityInfoForm = this.fb.group({});
    const modelData = this.modelData();
    const modelDataValue = this.modelData();
    const modelDataVal = this.modelData();
    const modelDataInput = this.modelData();
    this.TaskApportunityInfoForm = this.fb.group({
      taskTitle: new UntypedFormControl(modelData?.title ? modelData?.title : modelData?.latest_task?.title),
      taskNotes: new UntypedFormControl(this.taskNotes),
      value_in_minor_currency: modelDataValue?.value_in_minor_currency ? new UntypedFormControl(this.commonService.ConvertAmountFromMinorCurrency(modelDataValue?.value_in_minor_currency)) : new UntypedFormControl(0),
      scheduled_date: new UntypedFormControl(
        this.dateTimeService.ConvertUTCToLocalDateTime(
          modelDataVal?.scheduled_date ? modelDataVal?.scheduled_date : modelDataVal?.latest_task?.scheduled_date
        )
      ),
      expected_closure_date: modelDataInput.expected_closure_date ? new UntypedFormControl(
        this.dateTimeService.ConvertUTCToLocalDateTime(
          modelDataInput.expected_closure_date
        )) : new UntypedFormControl({ value: null, disabled: true })
      ,
      ddlselectedConvertibility: new UntypedFormControl(),
      ddlselectedOpportunity: new UntypedFormControl(),
      ddlselectedAssigned: new UntypedFormControl(),
      service_type_ids: new UntypedFormControl(),
    });
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      if (this.tenantId > 0) {
        this.store.dispatch({ type: 'ROUTER_GO' });
      }
    });

    this.store.select(COUNTRY_MASTER_STATE).subscribe((country: Country) => {
      this.country = country;
    });
    this.GetTaskNotes();

    this.BindUsers();
    this.BindServiceType();
    this.BindOpportunityStageMaster();

    const modelData_1 = this.modelData();
    if (modelData_1) {
      const selectedConvertibility = this.convertibility.find(
        (s: any) => s.name == this.modelData().hot_warm_cold
      );
      if (modelData_1.hot_warm_cold)
        this.TaskApportunityInfoForm.controls.ddlselectedConvertibility.setValue(
          selectedConvertibility,
          { onlySelf: true }
        );
      else
        this.TaskApportunityInfoForm.controls.ddlselectedConvertibility.disable();

        if(this.currentUserDetails && this.currentUserDetails['can_admin_client_profiles'] == 'false')
        {
          this.TaskApportunityInfoForm.controls.ddlselectedAssigned.disable();
        }

    }

    // this.SelectedAssignedFormControl
    //   .valueChanges
    //   .pipe(pairwise())
    //   .subscribe(([prev, next]: [any, any]) => {
    //     if (prev && next && prev.id != next.id) {
    //       this.UpdateAssignTo(event, this.TaskApportunityInfoForm);
    //     }
    //   });
  }

  getSelectedStaff(trainer: any) {
    this.UpdateAssignTo(trainer, this.TaskApportunityInfoForm)
  }



  GetTaskNotes() {
    // Use task's tenant_id instead of current user's tenant
    const taskTenantId = this.modelData()?.tenant_id || this.tenantId;
    const modelData = this.modelData();
    this.taskService
      .GetTask(taskTenantId, modelData.latest_task ? modelData.latest_task.id : modelData.id)
      .subscribe({
        next: (data: any) => {
          this.taskNotes = data.notes;
          this.TaskApportunityInfoForm.controls.taskNotes.setValue(
            this.taskNotes,
            { onlySelf: true }
          );
        },
        error: (error: AppErrors) => {
          this.errorMessages = [];
          if (error instanceof NotFoundError) {
            this.errMsg = error.originalError.message;
            this.errorMessages.push(error.originalError.message);
            this.errorDataModal = this.errorMessages;
            this.showErrorPopup$.next(true);
          } else {
            this.ReadErrorMessgaes(error);
          }
        },
      });
  }

  BindUsers(): void {
    const modelData = this.modelData();
    if (modelData) {
      this.assignedTo$.next(modelData?.latest_task?.assigned_to_staff_id ? modelData?.latest_task?.assigned_to_staff_id : modelData?.assigned_to_staff_id);
    }

  }

  BindServiceType(): void {
    // Use task's tenant_id instead of current user's tenant
    const taskTenantId = this.modelData()?.tenant_id || this.tenantId;
    this.serviceType.GetServiceType(taskTenantId).subscribe({
      next: (serviceTypes: ListServiceTypeResponse) => {
        this.serviceTypeCollection = serviceTypes.items;
        const modelData = this.modelData();
        if (modelData.service_type) {
          const selectedServiceType = serviceTypes.items.filter((allservice) => {
            return this.modelData().service_type.some(function (
              modelservice: any
            ) {
              return allservice.id === modelservice.id;
            });
          });
          if (modelData.service_type)
            this.TaskApportunityInfoForm.controls.service_type_ids.setValue(
              selectedServiceType
            );
          else this.TaskApportunityInfoForm.controls.service_type_ids.disable();
        }
      },
      error: (error) => {
        if (error instanceof NotFoundError) {
          this.errMsg = error.originalError.message;
        } else {
          this.errMsg = error.originalError.message;
        }
      },
    });
  }

  filterServiceType(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.serviceTypeCollection.length; i++) {
      const serviceType = this.serviceTypeCollection[i];
      if (
        serviceType.name_primary_language
          .toLowerCase()
          .indexOf(query.toLowerCase()) == 0 ||
        serviceType.name_secondary_language
          .toLowerCase()
          .indexOf(query.toLowerCase()) == 0
      ) {
        filtered.push(serviceType);
      }
    }

    this.filtertedServiceType = filtered;
  }

  BindOpportunityStageMaster(): void {
    this.store.select(STAGE_MASTER_STATE).subscribe((res: any) => {
      this.opportunityStageCollection = [];
      const opportunities = res as any;
      opportunities.forEach(
        (opportunityStage: OpportunityStageMasterResponse) => {
          this.opportunityStageCollection.push({
            name: opportunityStage.name_primary_language,
            value: opportunityStage.id,
          });
        }
      );
      const modelData = this.modelData();
      if (modelData) {
        const selectedOpportunity = this.opportunityStageCollection.find(
          (s) => s.value == this.modelData().stage_master_id
        );

        if (modelData?.stage_master_id)
          this.TaskApportunityInfoForm.controls.ddlselectedOpportunity.setValue(
            selectedOpportunity,
            { onlySelf: true }
          );
        else
          this.TaskApportunityInfoForm.controls.ddlselectedOpportunity.disable();
      }
    });
  }

  async EditTaskTitle(form: UntypedFormGroup) {
    this.taskTitleEdit = false;
    const updateTask: UpdateTask = {} as UpdateTask;
    updateTask.assigned_to_staff_id = form.getRawValue().ddlselectedAssigned?.id;
    updateTask.notes = form.getRawValue().taskNotes;
    updateTask.title = form.getRawValue().taskTitle;
    const modelData = this.modelData();
    updateTask.priority = modelData.priority ? modelData.priority : modelData.latest_task.priority;
    const modelDataValue = this.modelData();
    updateTask.scheduled_date = modelDataValue.latest_task ? modelDataValue.latest_task.scheduled_date : modelDataValue.scheduled_date;
    const modelDataVal = this.modelData();
    updateTask.category_id = modelDataVal.latest_task ? modelDataVal.latest_task.category_id : modelDataVal.category_id;
    updateTask.assigned_to_type = TaskAssignToType.SpecificStaff;
    await this.UpdateTask(updateTask).then((res) => {
      const modelDataInput = this.modelData();
      if (res) {
        const modelDataInput = this.modelData();
        if (modelDataInput.latest_task)
          modelDataInput.latest_task.title = form.getRawValue().taskTitle;
        else modelDataInput.title = form.getRawValue().taskTitle;
        this.UpdatedData.emit(modelDataInput);
      } else
        this.TaskApportunityInfoForm.controls.taskTitle.setValue(
          modelDataInput.latest_task ? modelDataInput.latest_task.title : modelDataInput.title,
          { onlySelf: true }
        );
    });
  }

  async EditTaskNotes(form: UntypedFormGroup) {
    this.taskNotesEdit = false;
    this.taskTitleEdit = false;
    const updateTask: UpdateTask = {} as UpdateTask;
    updateTask.assigned_to_staff_id = form.getRawValue().ddlselectedAssigned?.id;
    updateTask.notes = form.getRawValue().taskNotes;
    updateTask.title = form.getRawValue().taskTitle;
    const modelData = this.modelData();
    updateTask.priority = modelData.latest_task ? modelData.latest_task.priority : modelData.priority;;
    const modelDataValue = this.modelData();
    updateTask.scheduled_date = modelDataValue.latest_task ? modelDataValue.latest_task.scheduled_date : modelDataValue.scheduled_date;;
    const modelDataVal = this.modelData();
    updateTask.category_id = modelDataVal.latest_task ? modelDataVal.latest_task.category_id : modelDataVal.category_id;
    updateTask.assigned_to_type = TaskAssignToType.SpecificStaff;
    await this.UpdateTask(updateTask).then((res) => {
      const modelDataInput = this.modelData();
      if (res) {
        this.taskNotes = form.getRawValue().taskNotes;
        this.UpdatedData.emit(this.modelData());
      } else
        this.TaskApportunityInfoForm.controls.taskNotes.setValue(
          modelDataInput.latest_task ? modelDataInput.latest_task.title : modelDataInput.title,
          { onlySelf: true }
        );
    });
  }


  async UpdateAssignTo(e: any, form: UntypedFormGroup) {
    const updateTask: UpdateTask = {} as UpdateTask;
    updateTask.assigned_to_staff_id = form.getRawValue().ddlselectedAssigned?.id;
    updateTask.notes = form.getRawValue().taskNotes;
    updateTask.title = form.getRawValue().taskTitle;
    const modelData = this.modelData();
    updateTask.priority = modelData.latest_task ? modelData.latest_task.priority : modelData.priority;
    const modelDataValue = this.modelData();
    updateTask.scheduled_date = modelDataValue.latest_task ? modelDataValue.latest_task.scheduled_date : modelDataValue.scheduled_date;
    const modelDataVal = this.modelData();
    updateTask.category_id = modelDataVal.latest_task ? modelDataVal.latest_task.category_id : modelDataVal.category_id;
    updateTask.assigned_to_type = TaskAssignToType.SpecificStaff;
    await this.UpdateTask(updateTask).then((res) => {
      const modelDataInput = this.modelData();
      if (!res) {
        const selectedAssigned = this.assignedCollection.find(
          (s) => s.value == this.modelData().assigned_to_staff_id
        );
        this.TaskApportunityInfoForm.controls.ddlselectedAssigned.setValue(
          selectedAssigned,
          { onlySelf: true }
        );
      } else {
        modelDataInput.assigned_to_staff_id =
          form.getRawValue().ddlselectedAssigned?.id;
      }
      this.UpdatedData.emit(modelDataInput);
    });
  }

  async UpdateConvartability(e: any, form: UntypedFormGroup) {
    const updateOpportunity: UpdateOpportunityRequest = {} as UpdateOpportunityRequest;
    updateOpportunity.assigned_to_staff_id = form.getRawValue().ddlselectedAssigned?.id;
    updateOpportunity.comments = this.modelData().comments;
    updateOpportunity.expected_closure_date = this.modelData().expected_closure_date;
    updateOpportunity.hot_warm_cold = form.getRawValue().ddlselectedConvertibility?.name;
    updateOpportunity.name = this.modelData().name;
    updateOpportunity.service_type_ids = (form.getRawValue().service_type_ids || []).map(
      (s: { id: any }) => {
        return s.id;
      }
    );
    updateOpportunity.stage_master_id = form.getRawValue().ddlselectedOpportunity?.value;
    updateOpportunity.value_in_minor_currency = this.commonService.ConvertMinorCurrencyFromAmount(form.getRawValue().value_in_minor_currency);
    await this.UpdateOpportunity(updateOpportunity).then((res) => {
      const modelData = this.modelData();
      if (!res) {
        const selectedConvertibility = this.convertibility.find(
          (s: any) => s.name == this.modelData().hot_warm_cold
        );
        this.TaskApportunityInfoForm.controls.dlselectedConvertibility.setValue(
          selectedConvertibility,
          { onlySelf: true }
        );
      } else
        modelData.hot_warm_cold = form.getRawValue().ddlselectedConvertibility?.name;
      this.UpdatedData.emit(modelData);
    });
  }

  async UpdateOpportunityStatge(e: any, form: UntypedFormGroup) {
    const updateOpportunity: UpdateOpportunityRequest = {} as UpdateOpportunityRequest;
    updateOpportunity.assigned_to_staff_id = form.getRawValue().ddlselectedAssigned?.id;
    updateOpportunity.comments = this.modelData().comments;
    updateOpportunity.expected_closure_date = this.modelData().expected_closure_date;
    updateOpportunity.hot_warm_cold = form.getRawValue().ddlselectedConvertibility?.name;
    updateOpportunity.name = this.modelData().name;
    updateOpportunity.service_type_ids = (form.getRawValue().service_type_ids || []).map(
      (s: { id: any }) => {
        return s.id;
      }
    );
    updateOpportunity.stage_master_id = form.getRawValue().ddlselectedOpportunity?.value;
    updateOpportunity.value_in_minor_currency = this.commonService.ConvertMinorCurrencyFromAmount(form.getRawValue().value_in_minor_currency);
    await this.UpdateOpportunity(updateOpportunity).then((res) => {
      const modelData = this.modelData();
      if (!res) {
        const selectedOpportunity = this.opportunityStageCollection.find(
          (s) => s.value == this.modelData().stage_master_id
        );
        this.TaskApportunityInfoForm.controls.ddlselectedOpportunity.setValue(
          selectedOpportunity,
          { onlySelf: true }
        );
      } else
        modelData.stage_master_id = form.getRawValue().ddlselectedOpportunity?.value;
      this.UpdatedData.emit(modelData);
    });
  }

  async OnScheduleDateSelect(e: any) {
    const updateTask: UpdateTask = {} as UpdateTask;
    updateTask.assigned_to_staff_id = this.TaskApportunityInfoForm.getRawValue().ddlselectedAssigned?.id;
    updateTask.notes = this.TaskApportunityInfoForm.getRawValue().taskNotes;
    updateTask.title = this.TaskApportunityInfoForm.getRawValue().taskTitle;
    const modelData = this.modelData();
    updateTask.priority = modelData.latest_task ? modelData.latest_task.priority : modelData.priority;;

    updateTask.scheduled_date = e.toISOString();
    const modelDataValue = this.modelData();
    updateTask.category_id = modelDataValue.latest_task ? modelDataValue.latest_task.category_id : modelDataValue.category_id;
    updateTask.assigned_to_type = TaskAssignToType.SpecificStaff;
    await this.UpdateTask(updateTask).then((res) => {
      const modelDataVal = this.modelData();
      if (res) {
        if (modelDataVal.latest_task)
          modelDataVal.latest_task.scheduled_date = e;
        else modelDataVal.scheduled_date = e;
      } else {
        this.TaskApportunityInfoForm.controls.scheduled_date.setValue(
          new Date(modelDataVal.latest_task ? modelDataVal.latest_task.scheduled_date : modelDataVal.scheduled_date)
        );
      }
      this.dueDateEdit = false;
      this.UpdatedData.emit(modelDataVal);
    });
  }

  async OnExpectedClosureDateSelect(e: any) {
    const updateOpportunity: UpdateOpportunityRequest = {} as UpdateOpportunityRequest;
    updateOpportunity.assigned_to_staff_id = this.TaskApportunityInfoForm.getRawValue().ddlselectedAssigned?.id;
    updateOpportunity.comments = this.modelData().comments;
    updateOpportunity.expected_closure_date = this.dateTimeService.ConvertLocalDateTimeToUTC(e);
    updateOpportunity.hot_warm_cold = this.TaskApportunityInfoForm.getRawValue().ddlselectedConvertibility?.name;
    updateOpportunity.name = this.modelData().name;
    updateOpportunity.service_type_ids = (this.TaskApportunityInfoForm.getRawValue().service_type_ids || []).map(
      (s: { id: any }) => {
        return s.id;
      }
    );
    updateOpportunity.stage_master_id = this.TaskApportunityInfoForm.getRawValue().ddlselectedOpportunity?.value;
    updateOpportunity.value_in_minor_currency = this.commonService.ConvertMinorCurrencyFromAmount(this.TaskApportunityInfoForm.getRawValue().value_in_minor_currency);
    await this.UpdateOpportunity(updateOpportunity).then((res) => {
      const modelData = this.modelData();
      if (res) {
        modelData.expected_closure_date = e;
      } else {
        this.TaskApportunityInfoForm.controls.expected_closure_date.setValue(
          new Date(modelData.expected_closure_date)
        );
      }
      this.expectedDateEdit = false;
      this.UpdatedData.emit(modelData);
    });
  }

  async UpdateAmount(form: UntypedFormGroup) {
    const updateOpportunity: UpdateOpportunityRequest = {} as UpdateOpportunityRequest;
    updateOpportunity.assigned_to_staff_id = form.getRawValue().ddlselectedAssigned?.id;
    updateOpportunity.comments = this.modelData().comments;
    updateOpportunity.expected_closure_date = this.modelData().expected_closure_date;
    updateOpportunity.hot_warm_cold = form.getRawValue().ddlselectedConvertibility?.name;
    updateOpportunity.name = this.modelData().name;
    updateOpportunity.service_type_ids = (form.getRawValue().service_type_ids || []).map(
      (s: { id: any }) => {
        return s.id;
      }
    );
    updateOpportunity.stage_master_id = form.getRawValue().ddlselectedOpportunity?.value;
    updateOpportunity.value_in_minor_currency = this.commonService.ConvertMinorCurrencyFromAmount(form.getRawValue().value_in_minor_currency);
    await this.UpdateOpportunity(updateOpportunity).then((res) => {
      const modelData = this.modelData();
      if (res)
        modelData.value_in_minor_currency = this.commonService.ConvertMinorCurrencyFromAmount(form.getRawValue().value_in_minor_currency);
      else
        this.TaskApportunityInfoForm.controls.value_in_minor_currency.setValue(this.commonService.ConvertAmountFromMinorCurrency(modelData.value_in_minor_currency), { onlySelf: true });
      this.UpdatedData.emit(modelData);
    });
    this.amountEdit = false;
  }

  async UpdateServiceType(isRemoved: boolean, e: any, form: UntypedFormGroup) {
    if (isRemoved && form.controls.service_type_ids.value && form.controls.service_type_ids.value.length == 0) {
      this.translate.get('Shared.TASK-OPPORTUNITY-INFO.INTERESTEDIN_MIN_ERROR').subscribe((translation) => {
        this.toastMessageService.showErrorMessage(translation);
      });
      form.controls.service_type_ids.setValue([e]);
      return;
    }
    else {
      setTimeout(async () => {
        const updateOpportunity: UpdateOpportunityRequest = {} as UpdateOpportunityRequest;
        updateOpportunity.assigned_to_staff_id = form.getRawValue().ddlselectedAssigned?.id;
        updateOpportunity.comments = this.modelData().comments;
        updateOpportunity.expected_closure_date = this.modelData().expected_closure_date;
        updateOpportunity.hot_warm_cold = form.getRawValue().ddlselectedConvertibility?.name;
        updateOpportunity.name = this.modelData().name;
        updateOpportunity.service_type_ids = (form.getRawValue().service_type_ids || []).map(
          (s: { id: any }) => {
            return s.id;
          }
        );
        updateOpportunity.stage_master_id = form.getRawValue().ddlselectedOpportunity?.value;
        updateOpportunity.value_in_minor_currency = this.commonService.ConvertMinorCurrencyFromAmount(form.getRawValue().value_in_minor_currency);
        await this.UpdateOpportunity(updateOpportunity).then((res) => {
          const modelData = this.modelData();
          if (res) modelData.service_type = form.value.service_type_ids;
          else {
            const selectedServiceType = this.serviceTypeCollection.filter(
              (o: any) => {
                return this.modelData().service_type.some(function (o2: any) {
                  return o.id === o2.id;
                });
              }
            );
            this.TaskApportunityInfoForm.controls.service_type_ids.setValue(
              selectedServiceType
            );
          }
          this.UpdatedData.emit(modelData);
        });
      }, 3000);
    }
  }

  async UpdateTask(updateTask: UpdateTask): Promise<boolean> {
    let othis = this;
    // Use task's tenant_id instead of current user's tenant
    const taskTenantId = this.modelData()?.tenant_id || this.tenantId;
    let promise: Promise<boolean> = new Promise(function (resolve, reject) {
      const modelData = othis.modelData();
      othis.taskService
        .UpdateTaskService(
          taskTenantId,
          modelData.latest_task ? modelData.latest_task.id : modelData.id,
          updateTask
        )
        .subscribe({
          next: () => {
            othis.translate
              .get('Shared.TASK-OPPORTUNITY-INFO.TASK_UPDATE_MSG')
              .subscribe((translation) => {
                othis.toastMessageService.showSuccess(translation);
              });
            resolve(true);
          },
          error: (error: AppErrors) => {
            othis.errorMessages = [];
            if (error instanceof NotFoundError) {
              othis.errMsg = error.originalError.message;
              othis.errorMessages.push(error.originalError.message);
              othis.errorDataModal = othis.errorMessages;
              othis.showErrorPopup$.next(true);
            } else {
              othis.ReadErrorMessgaes(error);
            }
            resolve(false);
          },
        });
    });
    return promise;
  }

  UpdateOpportunity(updateOpportunity: UpdateOpportunityRequest) {
    let othis = this;
    // Use task's tenant_id instead of current user's tenant
    const taskTenantId = this.modelData()?.tenant_id || this.tenantId;
    let promise: Promise<boolean> = new Promise(function (resolve, reject) {
      othis.opportunityService
        .OpportunityUpdateService(
          taskTenantId,
          othis.modelData().board_type,
          othis.modelData().id,
          updateOpportunity
        )
        .subscribe({
          next: () => {
            othis.translate
              .get('Shared.TASK-OPPORTUNITY-INFO.OPPT_UPDATE_MSG')
              .subscribe((translation) => {
                othis.toastMessageService.showSuccess(translation);
              });
            resolve(true);
          },
          error: (error: AppErrors) => {
            othis.errorMessages = [];
            if (error instanceof NotFoundError) {
              othis.errMsg = error.originalError.message;
              othis.errorMessages.push(error.originalError.message);
              othis.errorDataModal = othis.errorMessages;
              othis.showErrorPopup$.next(true);
            } else {
              othis.ReadErrorMessgaes(error);
            }
            resolve(false);
          },
        });
    });
    return promise;
  }

  ReadErrorMessgaes(error: any) {
    if (error.originalError.status == 500) {
      this.errorMessages.push(error.originalError.error.errorMessage);
    }
    if (
      error.originalError.status == 400 ||
      error.originalError.status == 409
    ) {
      if (error.originalError.error.errors) {
        error.originalError.error.errors.forEach((e: any) => {
          this.errorMessages.push(e.errorMessage);
        });
      } else {
        if (error.originalError.error.length > 0) {
          error.originalError.error.forEach((e: any) => {
            this.errorMessages.push(e.errorMessage);
          });
        } else {
          this.errorMessages.push(error.originalError.error.errorMessage);
        }
      }
    } else {
      error.originalError.error.forEach((e: any) => {
        this.errorMessages.push(e.errorMessage);
      });
    }
    this.errorDataModal = this.errorMessages;
    this.showErrorPopup$.next(true);
    this.ErrorData.emit({ errors: this.errorMessages, showErrors: true });
  }

  HideErrorPopup(event: any) {
    this.showErrorPopup$?.next(false);
    this.errorMessages = [];
  }

  get SelectedOpportunity() {
    return this.TaskApportunityInfoForm.controls.ddlselectedOpportunity.value;
  }

  get SelectedConvertibility() {
    return this.TaskApportunityInfoForm.controls.ddlselectedConvertibility.value;
  }

  get SelectedAssigned() {
    return this.SelectedAssignedFormControl.value;
  }

  get SelectedAssignedFormControl(): UntypedFormControl {
    return this.TaskApportunityInfoForm.controls.ddlselectedAssigned as UntypedFormControl;
  }


}


interface Option {
  name: string;
  value: number;
}

interface Assigned {
  name: string;
  value: number;
  avatar: string;
}
